module.exports = __webpack_public_path__ + "img/1-place-medal-simple.2457ff25.svg";